import i18n from '@/i18n'

export interface SelectItem {
	text: string
	value: any
}

export const TextField = 'text'
export const ValueField = 'value'

export function selectItem(key: string | number, value: any): SelectItem {
	return {
		text: i18n.global.t(key),
		value,
	}
}
